import { useIntl } from 'react-intl';
import { useMutation, useQuery } from '@tanstack/react-query';
import { handleErrorNotification } from 'Common/utils';
import { useApiClient } from '../../../utils/apiClient';

export const useOrganizationToken = ({ enabled }: { enabled: boolean }) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['subscription', 'token'],
    queryFn: apiClient.Settings.BusinessApi.getOrganizationToken,
    // Hide until Chargebee migration is complete
    // onError: (error) => {
    //   handleErrorNotification({
    //     error,
    //     lang: intl.locale.toLowerCase(),
    //   });
    // },
    enabled,
    retry: false,
  });
};

export const useLatestSubscription = (
  org_token: string | undefined,
  merchant_id: string | undefined
) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['subscription', 'latest'],
    queryFn: () =>
      apiClient.Settings.BusinessApi.getLatestSubscription(
        org_token,
        merchant_id
      ),
    // Hide until Chargebee migration is complete
    // onError: (error) => {
    //   handleErrorNotification({
    //     error,
    //     lang: intl.locale.toLowerCase(),
    //   });
    // },
    enabled: Boolean(org_token && merchant_id),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000,
  });
};

export const usePortalSession = () => {
  const apiClient = useApiClient();
  const intl = useIntl();
  return useMutation({
    mutationFn: apiClient.Settings.BusinessApi.getPortalSession,
    onError: (error) => {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    },
    retry: false,
  });
};

export const useLatestSubscriptionWithPosAccount = (
  account_id: number | undefined,
  org_token: string | undefined
) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['subscription', 'latest', 'pos-account'],
    queryFn: () =>
      apiClient.Settings.BusinessApi.getLatestSubscriptionWithPosAccountId(
        account_id,
        org_token
      ),
    staleTime: 10000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export const useCollectNow = () => {
  const apiClient = useApiClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: ({
      org_token,
      merchant_id,
    }: {
      org_token: string;
      merchant_id: string;
    }) => apiClient.Settings.BusinessApi.collectNow(org_token, merchant_id),
    onError: (error) => {
      handleErrorNotification({
        error: (error as Error).message,
        lang: intl.locale.toLowerCase(),
      });
    },
  });
};
